import axios from 'axios';
import state from '../redux';
import authAction from '../redux/auth/action';
import { refresh_token_url } from 'constants/url';
import options from './options';

let isRefreshing = false;
let pendingRequests = [];

const processQueue = (error, token = null) => {
  pendingRequests.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  pendingRequests = [];
};

const funcRefreshToken = async () => {
  const { auth = {} } = state.getState();
  const refreshToken = auth?.refresh_token;

  if (isRefreshing) {
    try {
      const token = await new Promise(function (resolve, reject) {
        pendingRequests.push({ resolve, reject });
      });
      return token;
    } catch (err) {
      return await Promise.reject(err);
    }
  }
  if (refreshToken) {
    isRefreshing = true;

    return new Promise(function (resolve, reject) {
      const option = options('post', refresh_token_url, {
        refresh_token: refreshToken,
      });
      axios
        .request(option)
        .then(async (res) => {
          authAction.validatingToken(false);
          await authAction.setToken({
            access_token: res?.data?.data?.access_token,
            refresh_token: res?.data?.data?.refresh_token,
          });
          const tempAccesToken = res?.data?.data?.access_token;
          processQueue(null, res?.data?.data?.access_token);
          resolve(tempAccesToken);
        })
        .catch((err) => {
          localStorage.clear();
          processQueue(err, null);
          authAction.validatingToken(false);
          authAction.clearAuth();
          window.location.replace('/login');
          reject(err);
        })
        .then(() => {
          isRefreshing = false;
        });
    });
  }
};

export default funcRefreshToken;
